export const defaultConfigurationState = () => ({
  id: null,
  clientId: null,
  issExibility: null,
  taxRegime: null,
  cityServiceListItem: {
    code: null,
  },
  cityTaxCode: null,
  webserverUser: null,
  webserverPassword: null,
  webserverSecretPhrase: null,
  webserverAccessKey: null,
  webserverAuthorizationKey: null,
  irPercentage: null,
  csllPercentage: null,
  inssPercentage: null,
  cofinsPercentage: null,
  pisPercentage: null,
  production: null,
  culturalEncouraging: false,
  subtractTributes: false,
  series: [],
});

const initialState = {
  nfseConfigurations: { ...defaultConfigurationState() },
};

export default {
  ...initialState,
};
